export default __webpack_public_path__ + "static/media/dnd.0d2491c2.gif";